export enum UserRole {
    BUYER = 'ROLE_BUYER',
    SELLER = 'ROLE_SELLER',
    SUPPLIER = 'ROLE_SUPPLIER',
    ADMIN = "ROLE_ADMIN",
    ORDER_MANAGER = "ROLE_ORDER_MANAGER"
}